module.exports = __webpack_public_path__ + "img/my_license.9ac702c9.png";